import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../pages/Contact.css'; // Recycle CSS
import QuoteList from './QuoteList';
import UserManagement from './UserManagement';
import SOPEditor from './SOPEditor';
import QuoteItemManagement from './QuoteItemManagement';
import MyProfile from '../../pages/MyProfile';

const Dashboard: React.FC = () => {
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState('quotes');
    const [userRole, setUserRole] = useState('');
    const [username, setUsername] = useState('');

    useEffect(() => {
        const token = localStorage.getItem('token');
        const role = localStorage.getItem('role');
        const user = localStorage.getItem('username');

        if (!token) {
            navigate('/cil/login');
            return;
        }
        setUserRole(role || '');
        setUsername(user || '');

        // Redirect staff trying to access restricted tabs
        if (role !== 'admin' && (activeTab === 'users' || activeTab === 'sop' || activeTab === 'quote-items')) {
            setActiveTab('quotes');
        }
    }, [navigate, activeTab]);

    const handleLogout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('role');
        localStorage.removeItem('username');
        navigate('/cil/login');
    };

    return (
        <div style={{ paddingBottom: '50px', backgroundColor: '#f5f7f9', minHeight: '100vh' }}>
            {/* Fixed Header */}
            <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                height: '70px',
                backgroundColor: 'white',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '0 40px',
                zIndex: 1000
            }}>
                <h1 style={{ fontSize: '24px', margin: 0 }}>
                    {userRole === 'admin' ? '관리자 대시보드' : '대시보드'}
                </h1>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <span style={{ marginRight: '20px', fontSize: '14px', color: '#555' }}>
                        안녕하세요, <strong>{username}</strong>님 ({userRole === 'admin' ? '관리자' : '직원'})
                    </span>
                    <button
                        onClick={handleLogout}
                        className="btn btn-outline"
                        style={{
                            padding: '5px 15px',
                            fontSize: '13px',
                            borderRadius: '20px',
                            borderColor: '#ddd',
                            color: '#666'
                        }}
                    >
                        로그아웃
                    </button>
                </div>
            </div>

            {/* Main Content Area */}
            <div style={{ paddingTop: '100px', width: '100%', boxSizing: 'border-box', paddingLeft: '40px', paddingRight: '40px' }}>

                <div className="tabs" style={{ display: 'flex', borderBottom: '2px solid #ddd', marginBottom: '20px' }}>
                    <button
                        style={{ padding: '10px 20px', cursor: 'pointer', border: 'none', background: 'none', fontWeight: activeTab === 'quotes' ? 'bold' : 'normal', borderBottom: activeTab === 'quotes' ? '3px solid #0056b3' : 'none', color: activeTab === 'quotes' ? '#0056b3' : '#666' }}
                        onClick={() => setActiveTab('quotes')}
                    >
                        견적 요청 목록
                    </button>
                    {userRole !== 'admin' && (
                        <button
                            style={{ padding: '10px 20px', cursor: 'pointer', border: 'none', background: 'none', fontWeight: activeTab === 'profile' ? 'bold' : 'normal', borderBottom: activeTab === 'profile' ? '3px solid #0056b3' : 'none', color: activeTab === 'profile' ? '#0056b3' : '#666' }}
                            onClick={() => setActiveTab('profile')}
                        >
                            내 정보 수정
                        </button>
                    )}
                    {userRole === 'admin' && (
                        <>
                            <button
                                style={{ padding: '10px 20px', cursor: 'pointer', border: 'none', background: 'none', fontWeight: activeTab === 'users' ? 'bold' : 'normal', borderBottom: activeTab === 'users' ? '3px solid #0056b3' : 'none', color: activeTab === 'users' ? '#0056b3' : '#666' }}
                                onClick={() => setActiveTab('users')}
                            >
                                사용자 관리
                            </button>
                            <button
                                style={{ padding: '10px 20px', cursor: 'pointer', border: 'none', background: 'none', fontWeight: activeTab === 'sop' ? 'bold' : 'normal', borderBottom: activeTab === 'sop' ? '3px solid #0056b3' : 'none', color: activeTab === 'sop' ? '#0056b3' : '#666' }}
                                onClick={() => setActiveTab('sop')}
                            >
                                SOP 관리
                            </button>
                            <button
                                style={{ padding: '10px 20px', cursor: 'pointer', border: 'none', background: 'none', fontWeight: activeTab === 'quote-items' ? 'bold' : 'normal', borderBottom: activeTab === 'quote-items' ? '3px solid #0056b3' : 'none', color: activeTab === 'quote-items' ? '#0056b3' : '#666' }}
                                onClick={() => setActiveTab('quote-items')}
                            >
                                견적 항목 관리
                            </button>
                        </>
                    )}
                </div>

                <div className="tab-content">
                    {activeTab === 'quotes' && <QuoteList />}
                    {activeTab === 'users' && userRole === 'admin' && <UserManagement />}
                    {activeTab === 'sop' && userRole === 'admin' && <SOPEditor />}
                    {activeTab === 'quote-items' && userRole === 'admin' && <QuoteItemManagement />}
                    {activeTab === 'profile' && <MyProfile />}
                </div>
            </div>
        </div>
    );
};

export default Dashboard;
